module.exports = __webpack_public_path__ + "img/daniel.bcd7bc07.png";